type Furnishing = {
	code: string;
	name: string;
	icon: string;
	order: number;
	importance: number;
	type: string[];
	category?: string;
};

export const furnishingsInfo: Furnishing[] = [
	{
		code: "cupboard",
		name: "Cupboard",
		icon: "/images/furnishings/cupboard.svg",
		order: 1,
		importance: 3,
		type: ["storage"],
		category: "bedroom",
	},
	{
		code: "dressingTable",
		name: "Dressing Table",
		icon: "/images/furnishings/dressing-table.svg",
		order: 2,
		importance: 2,
		type: ["furniture"],
		category: "bedroom",
	},
	{
		code: "tvCabinet",
		name: "TV Cabinet",
		icon: "/images/furnishings/tv-cabinet.svg",
		order: 3,
		importance: 2,
		type: ["furniture", "entertainment"],
		category: "living",
	},
	{
		code: "wardrobes",
		name: "Wardrobes",
		icon: "/images/furnishings/wardrobes.svg",
		order: 4,
		importance: 4,
		type: ["storage"],
		category: "bedroom",
	},
	{
		code: "expensivePaintings",
		name: "Expensive Paintings",
		icon: "/images/furnishings/paintings.svg",
		order: 5,
		importance: 1,
		type: ["decor"],
		category: "living",
	},
	{
		code: "decorativeElectricalFittings",
		name: "Decorative Electrical Fittings",
		icon: "/images/furnishings/decorative-electrical-fittings.svg",
		order: 6,
		importance: 2,
		type: ["electrical", "decor"],
		category: "general",
	},
	{
		code: "storageCabinets",
		name: "Storage Cabinets",
		icon: "/images/furnishings/storage-cabinet.svg",
		order: 7,
		importance: 3,
		type: ["storage"],
		category: "general",
	},
	{
		code: "geysers",
		name: "Geysers",
		icon: "/images/furnishings/geyser.svg",
		order: 8,
		importance: 4,
		type: ["appliance"],
		category: "bathroom",
	},
	{
		code: "bathTubs",
		name: "Bath Tubs",
		icon: "/images/furnishings/bath-tub.svg",
		order: 9,
		importance: 2,
		type: ["bathroom"],
		category: "bathroom",
	},
	{
		code: "jacuzzi",
		name: "Jacuzzi",
		icon: "/images/furnishings/bath-tub.svg",
		order: 10,
		importance: 1,
		type: ["bathroom", "luxury"],
		category: "bathroom",
	},
	{
		code: "kitchenCabinet",
		name: "Kitchen Cabinet",
		icon: "/images/furnishings/kitchen-cabinet.svg",
		order: 11,
		importance: 4,
		type: ["storage"],
		category: "kitchen",
	},
	{
		code: "kitchenChimney",
		name: "Kitchen Chimney",
		icon: "/images/furnishings/chimney.svg",
		order: 12,
		importance: 3,
		type: ["appliance"],
		category: "kitchen",
	},
	{
		code: "ovens",
		name: "Ovens",
		icon: "/images/furnishings/oven.svg",
		order: 13,
		importance: 2,
		type: ["appliance"],
		category: "kitchen",
	},
];

export const getFurnishingInfo = (code: string): Furnishing | undefined => {
	return furnishingsInfo.find(furnishing => furnishing.code === code);
};

export const getFurnishingsByCategory = (category: string): Furnishing[] => {
	return furnishingsInfo.filter(furnishing => furnishing.category === category);
};

export const getFurnishingsByType = (type: string): Furnishing[] => {
	return furnishingsInfo.filter(furnishing => furnishing.type.includes(type));
};

// Map furnishing names to codes for better matching
const furnishingNameMap: Record<string, string> = {
	cupboard: "cupboard",
	"dressing table": "dressingTable",
	"tv cabinet": "tvCabinet",
	wardrobes: "wardrobes",
	"expensive paintings": "expensivePaintings",
	"decorative electrical fittings": "decorativeElectricalFittings",
	"storage cabinets": "storageCabinets",
	geysers: "geysers",
	"bath tubs": "bathTubs",
	jacuzzi: "jacuzzi",
	"kitchen cabinet": "kitchenCabinet",
	"kitchen cabinets": "kitchenCabinet",
	chimney: "kitchenChimney",
	"kitchen chimney": "kitchenChimney",
	ovens: "ovens",
};

export const getFurnishingInfoByName = (name: string): Furnishing | undefined => {
	const normalizedName = name.toLowerCase().trim();
	const code = furnishingNameMap[normalizedName];

	if (code) {
		return getFurnishingInfo(code);
	}

	// Fallback: try partial matching
	for (const [mappedName, mappedCode] of Object.entries(furnishingNameMap)) {
		if (normalizedName.includes(mappedName) || mappedName.includes(normalizedName)) {
			return getFurnishingInfo(mappedCode);
		}
	}

	return undefined;
};
